import lang from "@/views/modules/Notifications/language/en";
//import Editor from '@tinymce/tinymce-vue';
export default {
    name: "edit-notification",
    components: {
//        'editor': Editor,
    },
    data() {
        return {
            loading: true,
            notification: {},
            lang:[],
        }
    },
    mounted() {
        this.getNotification();
        this.lang = lang;
    },
    methods: {
        saveNotification() {
            const self = this;
            self.loading = true;
            axios.put('api/modules/notifications/' + self.$route.params.id, self.notification).then(function () {
                self.loading = false;
                self.$notify({
                    title: self.$i18n.t('Success').toString(),
                    text: self.$i18n.t('Data updated correctly').toString(),
                    type: 'success'
                });
            }).catch(function () {
                self.loading = false;
            });
        },
        getNotification() {
            const self = this;
            self.loading = true;
             window.currentAction = 'list';
                axios.get('api/modules/notifications/' + self.$route.params.id).then(function (response) {
                self.notification = response.data;
                self.loading = false;
            }).catch(function () {
                self.loading = false;
            });
        },
        
    }
}